import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { useModals } from "@/lib/modal-context";

const POINTS = [
    "Style selection guidance",
    "Space planning discussion",
    "Budget expectation clarity",
    "45-day execution feasibility check",
];

export default function LaunchOffer() {
    const { openConnect } = useModals();
    return (
        <section className="bg-white py-12 sm:py-16">
            <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    {/* Left card */}
                    <div className="rounded-3xl bg-[#FFFDE8] p-8 sm:p-10 fade-up">
                        <h3 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">
                            Launch Offer for Dubai Homeowners.
                        </h3>
                        <p className="mt-3 text-sm text-black/65 max-w-md">
                            Book a free specialist call and get a premium home consultation before you commit to a full project.
                        </p>
                        <ul className="mt-6 space-y-3">
                            {POINTS.map((p) => (
                                <li key={p} className="flex items-start gap-3 text-sm">
                                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#CCFF00]">
                                        <Check className="h-3.5 w-3.5 text-black" />
                                    </span>
                                    <span className="font-medium">{p}</span>
                                </li>
                            ))}
                        </ul>
                        <button
                            onClick={() => openConnect({ source: "launch_offer" })}
                            data-testid="launch-claim-consultation"
                            className="mt-8 btn-pill btn-lime pr-1.5"
                        >
                            <span className="px-1 text-sm font-bold">CLAIM FREE CONSULTATION</span>
                            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-black text-[#CCFF00]">
                                <ArrowRight className="h-4 w-4" />
                            </span>
                        </button>
                    </div>

                    {/* Right card */}
                    <div className="rounded-3xl bg-white border border-black/10 p-8 sm:p-10 fade-up">
                        <h3 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">
                            Why homeowners delay interiors?
                        </h3>
                        <p className="mt-4 text-sm text-black/65 leading-relaxed">
                            Too many vendors. Too many material options. Too much confusion around budget, quality and timeline. 45DaySpaces is built to make the decision easier: choose a style, connect with a specialist, get a structured plan, and move toward execution with confidence.
                        </p>
                        <a
                            href="#services"
                            data-testid="launch-start-vibes"
                            className="mt-8 btn-pill btn-outline-dark pr-1.5 inline-flex"
                        >
                            <span className="px-1 text-sm font-bold">START WITH VIBES</span>
                            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#CCFF00] text-black">
                                <ArrowRight className="h-4 w-4" />
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
